import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Layout from '@layout/PaymentLayout/PaymentLayout';
import { mediaQuery, Spacings } from '@styles/index';

const CustomLayout = styled(Layout)`
  .container {
    margin-top: ${Spacings.SPACING_10B};
    min-height: calc(100vh - ${Spacings.SPACING_24B});
    ${mediaQuery.uptoMobile} {
      margin-top: ${Spacings.SPACING_4B};
      padding: 0px;
    }
  }
`;

const PaymentPageLayout = ({ children }) => (
  <CustomLayout shadow ram={1}>
    {children}
  </CustomLayout>
);

PaymentPageLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default PaymentPageLayout;
